import { createStore } from 'satcheljs';
import getDefaultSignatureStore from '../utils/getDefaultSignatureStore';
import type { SignatureStore, SignatureStoreMap } from './schema/SignatureStore';
import { ObservableMap } from 'mobx';

const getStoreMap = createStore<SignatureStoreMap>('signature-map', {
    entries: new ObservableMap<string, SignatureStore>(),
});

const storeMap = getStoreMap();

export function getSignatureStore(accountSourceId: string) {
    let storeEntry = storeMap.entries.get(accountSourceId);
    if (!storeEntry) {
        storeEntry = getDefaultSignatureStore();
        storeMap.entries.set(accountSourceId, storeEntry);
    }

    return storeEntry;
}
